import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Program, Contact } from '../../../../../shared/model';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

import { BehaviorSubject } from 'rxjs';
import {
  ProgramFunctionContactService,
  ContactService,
  FunctionContactService,
  ProgramAnalystService,
  ProgramTaskService,
  ProgramTaskDetailService,
  ProgramTaskDetailById
} from '../../../camtl.service';
import {
  ProgramService,
  ProgramDetailService,
  ProgramDetailByIdService
} from '../../../../mesc/mesc.service';
import { parseDate } from '@progress/kendo-angular-intl';

@Component({
  selector: 'program-setup',
  templateUrl: 'program-setup.component.html',
})
export class ProgramSetupComponent implements OnInit {
  constructor(
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private formBuilder: FormBuilder,
    private programFunctionContactService: ProgramFunctionContactService,
    private programDetailService: ProgramDetailService,
    private programDetailByIdService: ProgramDetailByIdService,
    private programAnalystService: ProgramAnalystService,
    private programTaskService: ProgramTaskService,
    private programTaskDetailService: ProgramTaskDetailService,
    private contactService: ContactService,
    private functionContactService: FunctionContactService,
    public programService: ProgramService,
    public programTaskDetailById: ProgramTaskDetailById
  ) { }

  public programState: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  ngOnInit() {

    this.programService.query("?$filter=IsActive eq true");
    this.programService
      .subscribe(data => {
        data.map(x => x.Description = x.ProgramCode + ' - ' + x.ProgramDescription);
      });
    this.programTaskService.query();
    this.contactService.read("", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        response[i]["FullName"] = response[i].FirstName + " " + response[i].LastName;
      }
    });
  }

  gridFilter: boolean;

  // Program Select
  selectedProgram: any = undefined;
  dataResultPrograms: Array<Program>;
  contentTypeItems: Array<string> = ["Major", "Minor", "MCE", "Other"];
  contentType: string;

  // Program Details
  isNewProgramDetail: boolean = false;


  // Program Contacts
  isShowDialog: boolean = false;
  editDataItem: any = undefined; // Program Contacts grid view
  addDataItem: any = undefined;  // Program Contact grid row  
  userDataItem: any = undefined; // Add contact dialog
  programSetupTaskDataItem: any = undefined; // Program Setup Task grid row


  selectedProgramDetail: any;

  addFunctionContact = (event, dataItem, editService, system, callbackInputs) => {
    this.addDataItem = dataItem;
    this.userDataItem = new Contact();
    this.isShowDialog = true;
  }



  /**
   * This method is called when editing a program setup row
   * This method populates the function contacts for the selected function/row,
   * sets the editDataItem and FunctionId and removes the Id from the editDataItem
   * (note) - the dataItem.Id represents a FunctionId
   * @param dataItem - data for the selected row
   */
  handleGridEdit(dataItem) {
    this.functionContactService.read("/" + dataItem.dataItem.Id, true);
    this.editDataItem = dataItem.dataItem;
    this.editDataItem.FunctionId = dataItem.dataItem.Id;
    delete this.editDataItem.Id;
  }


  /**
   * This method updates editDataItem for the selected row
   * - Toggles on dialog visibility
   * @param dataItem - data for the selected row
   */
  editHandler({ sender, rowIndex, dataItem }) {
    this.editDataItem = dataItem;
    this.isShowDialog = true;
  }


  /**
   * This method is called after Save is called by the dialog
   * - Adds the functionId from the selected dataItem (gridRow)
   * - Calls programContactService to add the function contact
   * - Refreshes data for 'Completed By' dropdowns
   * - Toggles off dialog visibility
   * @param props - User from GPLD Lookup
   */
  saveHandler(dataItem) {
    var self = this;
    dataItem.FunctionIds = [this.addDataItem.Id];
    let response: Promise<any> = this.contactService.save(dataItem, true);
    response.then((res) => {
      this.functionContactService.getById(this.addDataItem.Id);
      this.editDataItem = undefined;
      this.isShowDialog = false;
      self.cgpSnackbarService.showSnackbar({
        message: "Contact has been created",
        duration: 2000
      })
    });
  }


  /**
   * This method is called after Cancel is called by the dialog
   * - Resets the editDataItem
   * - Toggles off dialog visibility
   */
  cancelHandler() {
    this.editDataItem = undefined;
    this.isShowDialog = false;
  }

  handleError(err) {
    this.programDetailByIdService.loading.next(false);
    switch (err.status) {
      case 404:
        this.isNewProgramDetail = true;
        break;
      default:
        break;
    }
  }

  reset() {
    this.programFunctionContactService.reset();
    this.programDetailByIdService.reset();
    this.selectedProgram = undefined;
    // this.dataResultPrograms = undefined;
    this.editDataItem = undefined;
    this.isShowDialog = false;
    this.addDataItem = undefined;
    this.userDataItem = undefined;
    this.programSetupTaskDataItem = undefined;
  }

  /**
   * This method sets the selectedProgram and filters the grid based on the ProgramId
   * Else case - the input was cleared - reset the grid
   * @param value - The selected Program
   */
  handleProgramChange(dataItem) {
    if (dataItem == undefined) {
      this.reset();
    }
    else {
      this.selectedProgram = dataItem;
      this.refresh();
      this.readProgramSetupTask();
      this.template.fileName = "ProgramContacts - " + this.selectedProgram.ProgramCode + ".xlsx";
      this.programSetupTaskTemplate.fileName = "ProgramSetupTasks - " + this.selectedProgram.ProgramCode + ".xlsx";
    }
  }

  /**
   * This method uses the date input and returns a Date object formatted for a Kendo Datepicker
   * else case - return today's date
   * @param date - Datetime string
   */
  stringToDate(date: string): Date {
    try {
      return date ? parseDate(date) : new Date();
    } catch (e) {
      return new Date();
    }
  }
  dateToString(date: Date): string {
    try {
      return date.toISOString();
    } catch (e) {
      return undefined;
    }
  }

  /**
  * This method updates the program contacts tab and grid,
  * updates the program details data, and formats the program detail dates
  */
  refresh() {
    if (this.selectedProgram) {
      this.programDetailByIdService.read("/" + this.selectedProgram.Id + "/detail", true, false)
        .then(data => {
          if (data) {
            data['VPIDate'] = this.stringToDate(data['VPIDate']);
            data['CSDate'] = this.stringToDate(data['CSDate']);
            data['SORPDate'] = this.stringToDate(data['SORPDate']);
            this.selectedProgramDetail = data.Id;
          } else {
            this.isNewProgramDetail = true;
          }
          this.editForm.reset(data);
        })
        .catch(err => this.handleError(err))
      // this.programFunctionContactService.read("/" + this.selectedProgram.ProgramCode, true);
      this.programFunctionContactService.read("/programId/" + this.selectedProgram.Id, true)

      this.gridFilter = !this.gridFilter;
    }
    else {
      this.reset();
    }
  }

  /**
   * This method calls Program Detail Service save method
   * Refreshes grid
   */
  onSave() {
    let dataItem = this.editForm.value;
    dataItem.ProgramId = this.selectedProgram.Id;
    dataItem.VPIDate = this.dateToString(dataItem.VPIDate);
    dataItem.SORPDate = this.dateToString(dataItem.SORPDate);
    dataItem.CSDate = this.dateToString(dataItem.CSDate);

    let response: Promise<any> = this.programDetailService.save(dataItem, this.isNewProgramDetail);
    response
      .then((res) => {
        this.isNewProgramDetail = false;
        this.refresh();
        this.cgpSnackbarService.showSnackbar({
          message: 'Record has been updated',
          duration: 2000
        });
      })
      .catch((res) => {
        this.programDetailService.loading.next(false);
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: res._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      });
  }


  getShortDate(date): string {
    return new Date(date).toDateString();
  }


  /**
   * 
   */
  onCancel() {
    this.reset();
  }

  setModelHandler() { }
  editedRowIndex: number;
  closeEditor(grid: any, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.programSetupTaskDataItem = undefined;
  }

  saveContact = (dataItem, isNew) => {
    var self = this;
    isNew = true;

    this.programFunctionContactService.save(dataItem, isNew).then(function () {
      self.refresh();
      self.cgpSnackbarService.showSnackbar({
        message: isNew ? "Contact has been assigned" : "Contact has been updated",
        duration: 2000
      })
    })
  }

  editForm = this.formBuilder.group({
    Id: [],
    CreatedBy: [],
    CreatedDate: [],
    ProgramId: [],
    SORPDate: [],
    VPIDate: [],
    CSDate: [],
    ProgramContentType: [],
  })

  programContactForm = this.formBuilder.group({
    CreatedBy: [],
    CreatedDate: [],
    ContactId: ["", Validators.required],
    FunctionId: [],
    ProgramId: [],
  })

  functionContactForm = this.formBuilder.group({
    Id: [],
    GMIN: ["", Validators.required],
    FirstName: [],
    LastName: [],
    Email: [],
    FunctionIds: [{ value: [] }],
    CreatedBy: [],
    CreatedDate: [],
  })

  formDialog = {
    title: "Function Contact",
    formControls: [
      {
        type: "person",
        name: "GMIN",
        title: "GMIN/GMID",
        service: this.contactService,
      }],
    service: this.contactService
  }

  columns = [
    {
      field: 'Description',
      title: 'Function',
      //width: 200,
    }, {
      field: 'ContactName',
      title: 'Contact',
      width: 400,
      template: {
        type: 'combobox',
        textField: 'ContactName',
        valueField: 'ContactId',
        placeholder: 'Select Function Contact',
        service: this.functionContactService,
      }
    }
  ]

  template = {
    controls: {
      add: false,
      edit: true,
      delete: false,
      excel: true,
      width: 150,
      custom: [
        {
          id: "addFunctionContact",
          class: "fa fa-user-plus",
          callback: this.addFunctionContact,
          title: 'Add Function Contact',
        }
      ]
    },
    columns: this.columns,
    service: this.programFunctionContactService,
    method: 'custom',
    save: this.saveContact,
    fileName: "program_contacts.xlsx"
  }

  // -------------Program Setup------------- //

  readProgramSetupTask = () => {
    var self = this;
    if (this.selectedProgram) {
      return self.programTaskDetailById
        .read("/" + this.selectedProgram.Id + "/programtaskdetail", true)
        .then((x) => {
          self.programDetailByIdService.loading.next(false);
          return x;
        });
    }
    return Promise.resolve([]);
  }

  editProgramSetupTask = (dataItem, isDetailRow) => {
    var self = this;

    dataItem['CompletedDate'] = self.stringToDate(dataItem['CompletedDate']);

    this.programFunctionContactService.read("/programId/" + this.selectedProgram.Id, true).then(response => {
      // this.programFunctionContactService.read("/" + this.selectedProgram.ProgramCode, true).then(function (response) {
      var uniqueNames = [];
      self.programFunctionContactService.data = [];
      for (var i = 0; i < response.length; i++) {
        if (uniqueNames.indexOf(response[i].ContactName) === -1 && response[i].ContactName != "" && response[i].ContactName != " ") {
          uniqueNames.push(response[i].ContactName);
          self.programFunctionContactService.data.push(response[i]);
        }
      }
    });
  }

  saveProgramSetupTask = (dataItem, isNew) => {
    var self = this;

    dataItem.CompletedDate = this.dateToString(dataItem.CompletedDate);

    return this.programTaskDetailService.save(dataItem, true, "", false, false, false).then(function () {
      self.refresh();
      self.readProgramSetupTask();
      self.cgpSnackbarService.showSnackbar({
        message: isNew ? "Contact has been assigned" : "Contact has been updated",
        duration: 2000
      })
    })
  }

  programSetupTaskEditForm = this.formBuilder.group({
    Id: [""],
    CreatedBy: [""],
    CreatedDate: [""],
    ProgramId: [""],
    ProgramTaskId: [""],
    ContactId: [""],
    CompletedDate: [""]
  })

  private programSetupTaskFormDialog = {
    title: "Contact",
    formControls: [
      {
        type: 'combobox',
        name: 'ContactId',
        title: 'Name',
        textField: 'ContactName',
        valueField: 'ContactId',
        placeholder: 'Select Contact...',
        service: this.programFunctionContactService,
        sync: true
      },
      {
        type: 'date',
        name: 'CompletedDate',
        title: 'Completed Date'
      }
    ]
  }

  programSetupTaskColumns = [
    {
      field: 'ProgramTaskName',
      title: 'Task',
    },
    {
      field: 'ContactName',
      title: 'Contact'
    },
    {
      field: 'CompletedDate',
      title: 'Completed Date',
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    }
  ]

  programSetupTaskTemplate = {
    controls: {
      add: false,
      edit: true,
      delete: false,
      excel: true,
      width: 65,
    },
    columns: this.programSetupTaskColumns,
    service: this.programDetailService,
    read: this.readProgramSetupTask,
    edit: this.editProgramSetupTask,
    save: this.saveProgramSetupTask,
    fileName: "ProgramSetupTasks.xlsx"
  }
}
